module.exports = __webpack_public_path__ + "static/media/LOGO-UNINFE.5f253642.png";